import { render, staticRenderFns } from "./DpvLotsTable.vue?vue&type=template&id=a409c534&scoped=true"
import script from "./DpvLotsTable.vue?vue&type=script&lang=js"
export * from "./DpvLotsTable.vue?vue&type=script&lang=js"
import style0 from "./DpvLotsTable.vue?vue&type=style&index=0&id=a409c534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a409c534",
  null
  
)

export default component.exports